import {debug} from "../utils";

export const ACTION_RESULTS_CHANGED = "ACTION_RESULTS_CHANGED"
export const ACTION_RESULTS_CHANGED_GET_ALL_RESULTS = "ACTION_RESULTS_CHANGED_GET_ALL_RESULTS"
//export const ACTION_RESULTS_CHANGED_VIEW_MODE = "ACTION_RESULTS_CHANGED_VIEW_MODE"

export function MlDetectionPageReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_RESULTS_CHANGED: {
            debug(`ReportsPageReducer ${ACTION_RESULTS_CHANGED} is being processed...`)
            return {...state, ...action.payload};
        }
        case ACTION_RESULTS_CHANGED_GET_ALL_RESULTS: {
            return { ...state, ...action.payload };
        }
        // case ACTION_RESULTS_CHANGED_VIEW_MODE: {
        //     return { ...state, ...action.payload };
        // }
        default:
            return state;
    }
}
